import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import '../../styles/components.css';

const Layout = () => {
  return (
    <div className="layout">
      <Navbar />
      <main className="layout-content">
        <Outlet />
      </main>
      <footer className="layout-footer">
        <p>&copy; 2026 Sistema de Gestión de Farmacias. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
};

export default Layout;

// Made with Bob
